<template>
    <div class="about">
        <!-- 顶部操作按钮区域 -->
        <div class="top-actions">
            <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
            <el-button type="default" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>

            <div class="search-container">
                <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
                <el-button type="default" icon="el-icon-search" @click="showSearchFields = !showSearchFields"></el-button>
            </div>
        </div>

        <!-- 高级搜索区域 -->
        <div v-if="showSearchFields" class="advanced-search-fields">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="任务ID">
                            <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名">
                            <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="采集源">
                            <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <el-input v-model="searchForm.creationTime" placeholder="请输入创建时间"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-button type="default" @click="handleAdvancedSearch">提交</el-button>
        </div>

        <!-- 数据表格 -->
        <el-table
            ref="filterTable"
            :data="pagedData"
            :header-cell-style="{ color: '#606266', background: '#f5f7fa' }"
            style="width: 100%"
            stripe
            border
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="user_id" label="任务id" sortable width="180" column-key="date"
                :filters="[{ text: '2016-05-01', value: '2016-05-01' }, { text: '2016-05-02', value: '2016-05-02' }, { text: '2016-05-03', value: '2016-05-03' }, { text: '2016-05-04', value: '2016-05-04' }]"
                :filter-method="filterHandler">
            </el-table-column>
            <el-table-column prop="source_keyword" label="任务名" width="180"></el-table-column>
             <!-- <el-table-column prop="publish_time" label="发布时间"></el-table-column>-->
            <el-table-column prop="publish_time" label="采集时间"></el-table-column>
            <el-table-column prop="title" label="笔记标题"></el-table-column>
            <el-table-column prop="comment_count" label="获客量"></el-table-column>
            <el-table-column prop="comment_count" label="评论筛选数"></el-table-column>

            <!-- 其他列根据需要添加 -->
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="currentPage"
                :page-size="pgSize"
                :total="totalItems"
                @current-change="handlePageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { xhs_note, xhs_note2, xhs_note3,xhs_note8, delete_xhs_note } from '@/api/xhs';
import moment from 'moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    data() {
        return {
            currentPage: 1, // 当前页码
            pgSize: 50, // 每页显示50条数据
            idx: -1,
            editVisible: false,
            form: {},
            searchQuery: '', // 搜索关键词
            showSearchFields: false, // 是否显示高级搜索字段
            searchForm: {
                taskId: '',
                taskName: '',
                collectionSource: '',
                creationTime: ''
            },
            selectedRows: [], // 已选中的行
            tableData: [] // 原始数据
        };
    },
    computed: {
        // 根据搜索关键词过滤表格数据
        filteredTableData() {
            if (!this.searchQuery) return this.tableData;
            const query = this.searchQuery.toLowerCase();
            return this.tableData.filter(data => {
                return Object.values(data).some(value => {
                    return String(value).toLowerCase().includes(query);
                });
            });
        },
        // 计算当前页的数据
        pagedData() {
            const start = (this.currentPage - 1) * this.pgSize;
            const end = start + this.pgSize;
            return this.filteredTableData.slice(start, end);
        },
        // 分页总数基于筛选后的数据
        totalItems() {
            return this.filteredTableData.length;
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        // 根据用户角色获取对应的API
        getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';

            // 定义角色与API的映射关系
            const apiMap = {
                'admin': xhs_note,
                'manager': xhs_note2,
                'zhuzhu': xhs_note3,
                'huolong':xhs_note3,
                'buzhi': xhs_note3,
                'ruiqi': xhs_note3,
                'daolai': xhs_note3,
                'yangguang': xhs_note3,
                'demo': xhs_note3,
                 'jinlianan': xhs_note3,
                 'jinlianan2': xhs_note3,
                'dianguang1': xhs_note3,
                'dianguang2':  xhs_note3,
                'dianguang3': xhs_note3,
                'demo': xhs_note8,
            };

            return apiMap[userRole] || xhs_note;
        },

        // 获取数据
        fetchData() {
            const api = this.getApiByRole();
            api().then(response => {
                console.log("[API 响应数据]", response.data);
                this.tableData = response.data.map(item => ({
                    user_id: item.user_id,
                    source_keyword: item.source_keyword,
                    publish_time: item.publish_time,
                    title: item.title,
                    comment_count: item.comment_count,
                    // 根据实际API返回的字段调整
                }));
            }).catch(error => {
                console.error('获取数据时出错！', error);
            });
        },

        // 导出数据
        handleExport() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要导出的行！');
                return;
            }

            const dataToExport = this.selectedRows.map(item => ({
                "任务id": item.user_id,
                "任务名": item.source_keyword,
                "发布时间": item.publish_time,
                "采集时间": item.publish_time, // 如果有单独的采集时间字段，请替换
                "笔记标题": item.title,
                "获客量": item.comment_count,
                "评论筛选数": item.comment_count, // 如果有单独的评论筛选数字段，请替换
                // 根据实际表格列，补充完整其他需要导出的字段
            }));

            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: "application/octet-stream" });
            saveAs(blob, '导出数据.xlsx');
        },

        // 刷新数据
        handleRefresh() {
            this.fetchData();
        },

        // 高级搜索
        handleAdvancedSearch() {
            const api = this.getApiByRole();
            const params = {
                taskId: this.searchForm.taskId,
                taskName: this.searchForm.taskName,
                collectionSource: this.searchForm.collectionSource,
                creationTime: this.searchForm.creationTime
            };
            api(params).then(response => {
                this.tableData = response.data.map(item => ({
                    user_id: item.user_id,
                    source_keyword: item.source_keyword,
                    publish_time: item.publish_time,
                    title: item.title,
                    comment_count: item.comment_count,
                    // 根据实际API返回的字段调整
                }));
                this.currentPage = 1; // 重置到第一页
            }).catch(error => {
                console.error('执行高级搜索时出错！', error);
            });

            this.showSearchFields = false;
        },

        // 删除选中行
        handleDeleteSelected() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要删除的行！');
                return;
            }

            const userIds = this.selectedRows.map(row => row.user_id);
            Promise.all(userIds.map(id => delete_xhs_note(id)))
                .then(() => {
                    this.$message.success('删除成功');
                    this.fetchData(); // 刷新数据以反映删除
                    this.selectedRows = []; // 清空选中项
                })
                .catch(error => {
                    this.$message.error('部分删除失败');
                    console.error('批量删除时出错！', error);
                });
        },

        // 删除单行
        handleDelete(index, row) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                delete_xhs_note(row.user_id).then(() => {
                    this.$message.success('删除成功');
                    this.fetchData(); // 刷新数据以反映删除
                    // 如果需要从selectedRows中移除，可以在这里处理
                }).catch(error => {
                    this.$message.error('删除失败');
                    console.error('删除时出错！', error);
                });
            }).catch(() => { });
        },

        // 分页变化
        handlePageChange(val) {
            this.currentPage = val;
        },

        // 选择行变化
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },

        // 格式化时间
        formatter(row, column) {
            if (column.property === 'publish_time') {
                return moment(row[column.property]).format('YYYY-MM-DD HH:mm:ss');
            }
            return row[column.property];
        },

        // 筛选处理
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },

        // 搜索处理
        handleSearch() {
            this.currentPage = 1; // 搜索后重置到第一页
        }
    }
}
</script>

<style lang="stylus">
.top-actions
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px

.search-container
    margin-left: auto

.button-container
    margin-right: auto

.advanced-search-fields {
    margin-bottom: 10px;
}


</style>